/**
 * Calculator Constants
 *
 * Centralized configuration for all mortgage calculator assumptions.
 * Update these values to adjust calculator behavior across all calculators.
 */

// ============================================================================
// STANDARD MORTGAGE CALCULATOR
// ============================================================================

export const MORTGAGE_CONSTANTS = {
  // Property Tax Rate (annual)
  PROPERTY_TAX_RATE: 0.02, // 2.0% of home value annually

  // Homeowner's Insurance Rate (annual)
  INSURANCE_RATE: 0.006, // 0.6% of home value annually

  // Private Mortgage Insurance (PMI) Rates by LTV
  PMI_RATE_90_95: 0.0089, // 0.89% annual for LTV > 90%
  PMI_RATE_85_90: 0.0057, // 0.57% annual for LTV 85-90%
  PMI_RATE_80_85: 0.0033, // 0.33% annual for LTV 80-85%

  // Minimum Down Payment
  MIN_DOWN_PAYMENT_PERCENT: 0.05, // 5% minimum down payment
  MAX_LTV_CONVENTIONAL: 0.95 // Maximum 95% LTV (5% down minimum)
};

// ============================================================================
// AFFORDABILITY CALCULATOR
// ============================================================================

export const AFFORDABILITY_CONSTANTS = {
  // Debt-to-Income Ratios
  MAX_HOUSING_DTI: 0.28, // 28% of gross income for housing expenses
  MAX_TOTAL_DTI: 0.36, // 36% of gross income for total debt (default, user adjustable)

  // Estimated Rates for Affordability Calculation
  ESTIMATED_TAX_RATE: 0.012, // 1.2% annual (conservative estimate)
  ESTIMATED_INSURANCE_RATE: 0.005 // 0.5% annual (conservative estimate)
};

// ============================================================================
// REFINANCE CALCULATOR
// ============================================================================

export const REFINANCE_CONSTANTS = {
  // Default Closing Costs
  DEFAULT_CLOSING_COSTS: 3000 // $3,000 default (user can adjust)
};

// ============================================================================
// RENT VS BUY CALCULATOR
// ============================================================================

export const RENT_VS_BUY_CONSTANTS = {
  // Appreciation Rates
  HOME_APPRECIATION_RATE: 0.03, // 3.0% annual home value appreciation
  RENT_APPRECIATION_RATE: 0.035, // 3.5% annual rent increase
  INVESTMENT_RETURN_RATE: 0.035, // 3.5% annual return on invested down payment

  // Ownership Costs
  MAINTENANCE_RATE: 0.01, // 1.0% of home value annually for maintenance
  SELLING_COST_RATE: 0.06, // 6.0% of home value for selling costs (commission, etc.)
  PROPERTY_TAX_RATE: 0.02, // 2.0% of home value annually
  INSURANCE_RATE: 0.006, // 0.6% of home value annually

  // Rental Costs
  RENTERS_INSURANCE_FACTOR: 0.0132, // 1.32% additional cost for renters insurance

  // Tax Benefits
  MORTGAGE_INTEREST_TAX_DEDUCTION: 0.15, // 15% tax savings on mortgage interest

  // FHA Threshold (applies upfront MIP if down payment < 5%)
  FHA_THRESHOLD_LTV: 0.95,
  UPFRONT_MIP_RATE: 0.0175,

  // Alternative Rent Appreciation (used in secondary calculation)
  RENT_APPRECIATION_RATE_ALT: 0.025 // 2.5% used in one of the rental cost calculations
};

// ============================================================================
// SHARED CONSTANTS (used across multiple calculators)
// ============================================================================

export const SHARED_CONSTANTS = {
  // Common property tax rate
  PROPERTY_TAX_RATE: 0.02, // 2.0% annual

  // Common insurance rate
  INSURANCE_RATE: 0.006, // 0.6% annual

  // Standard loan terms (in years)
  LOAN_TERM_30_YEARS: 30,
  LOAN_TERM_15_YEARS: 15,

  // Months per year (for calculations)
  MONTHS_PER_YEAR: 12
};
